import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { ListContainer, RounderContainer } from '@r1-frontend/ui-react/experimental/containers';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

export const RounderContainerWithBackground = styled(RounderContainer)`
    width: 736px;
    height: 288px;
    background: ${COLORS.BgSurface};

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        width: 592px;
        height: 236px;
    }

    @media (max-width: ${wideBreakpoints.laptop}) {
        width: 452px;
        height: 196px;
    }

    @media (max-width: ${wideBreakpoints.tablet}) {
        width: 360px;
        height: 170px;
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        width: 328px;
        height: 144px;
    }
`;

export const TextWrapperWithMargin = styled.div`
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    justify-content: space-between;
    padding: 72px;
    padding-right: 0;
    height: 100%;

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        padding: 54px;
        padding-right: 0;
    }

    @media (max-width: ${wideBreakpoints.laptop}) {
        padding: 40px;
        padding-right: 0;
    }

    @media (max-width: ${wideBreakpoints.tablet}) {
        padding: 32px;
        padding-right: 0;
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        padding: 24px;
        padding-right: 0;
    }    
`;

export const ListContainerWithAlign = styled(ListContainer)`
    justify-content: space-between;
    align-items: center;
    
    width: 100%;

    &,
    picture {
        height: 100%;
    }
`;

export const Image = styled.img`
    padding: 8px;
    width: auto;
    height: 100%;
    object-fit: cover;
`;
